module.exports = __webpack_public_path__ + "static/media/skillenza.d62913cd.png";